import { render, staticRenderFns } from "./StandappRecoverPasswordComponent.vue?vue&type=template&id=fe120110&"
import script from "./StandappRecoverPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./StandappRecoverPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports